export const noAccessStampAdminPermission = {
  "title": "",
  "extraContent": "",
  "noPermission": "",
  "eSignSystemError": "",
  "applyOrgStampUsePermission": "",
  "paramsError": "",
  "eSignOrgAuthCancel": "",
  "btn": "",
  "pagingSealErr1": "",
  "pagingSealErr2": "",
  "pagingSealErr3": "",
  "pagingSealErr4": ""
}